<form #formRef="ngForm" class="sidebar-active">
	<bb-page-header [backOnMobile]="['/library/placements']" [icon]="'square-o'" [title]="entity ? entity.name : 'PLACEMENT' | translate">
		<ul class="tabs" *ngIf="entity">
			<li>
				<a [routerLink]="['/library/placement', activeId, 'metadata']" routerLinkActive="" [class.active]="activeTab === 'metadata'"><!-- hack to fix routerLinkActive after create new -->
					<i class="fa fa-tags"></i> {{ 'METADATA' | translate }}
				</a>
			</li>
			<!-- <li>
				<a [routerLink]="['/library/placement', activeId, 'embed']" routerLinkActive="active">
					<i class="fa fa-code"></i> {{ 'EMBED' | translate }}
				</a>
			</li> -->
		</ul>

		<bb-status *ngIf="entity" [(ngModel)]="entity.status" name="status"></bb-status>

	</bb-page-header>

	<div class="body-column tab-container">
		<placement-details-metadata *ngIf="entity" [form]="form" [placement]="entity" [hidden]="activeTab !== 'metadata'"></placement-details-metadata>
	</div>
	<div class="body-column preview-container">
		<bb-entity-details
			[entity]="entity"
		></bb-entity-details>
	</div>
</form>

<bb-embed-bar embedPath="e" [entity]="entity"></bb-embed-bar>

<bb-actions-bar (onSave)="save($event)" (onCancel)="cancel()" (onDelete)="delete($event)" [form]="form" [entity]="entity">
</bb-actions-bar>
